// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__UnYjD","rootSmall":"AddTileButton_rootSmall__2uA7T"};